import axiosInstance from "../axiosConfig";
import { Course, CourseResponse } from "./courseService.types";

import { logger } from "utils/logger";

export interface CourseListFilters {
  categories?: string[];
}

// Получение списка курсов
export const fetchCourses = async (
  page: number = 1,
  pageSize: number = 7,
  ordering: string = "",
  filters: CourseListFilters = {},
): Promise<CourseResponse> => {
  const url = `/courses/`;
  try {
    const response = await axiosInstance.get<CourseResponse>(url, {
      params: {
        page,
        page_size: pageSize,
        ordering,
        category: filters.categories?.length ? filters.categories : undefined,
      },
    });
    return response.data;
  } catch (error) {
    logger.error("Ошибка при получении курсов:", error);
    throw error;
  }
};

export const fetchAllCourses = async (): Promise<Course[]> => {
  const url = `/courses/`;
  try {
    const response = await axiosInstance.get<Course[]>(url);
    return response.data;
  } catch (error) {
    logger.error("Ошибка при получении всех курсов:", error);
    throw error;
  }
};

// Получение курса по ID
export const fetchCourseById = async (id: number): Promise<Course> => {
  const url = `/courses/${id}/`;
  try {
    const response = await axiosInstance.get<Course>(url);
    return response.data;
  } catch (error) {
    logger.error("Ошибка при получении курса по ID:", error);
    throw error;
  }
};

// Удаление курса
export const deleteCourse = async (id: number): Promise<void> => {
  const url = `/courses/${id}/`;
  try {
    await axiosInstance.delete(url);
  } catch (error) {
    logger.error(`Ошибка при удалении курса с ID ${id}:`, error);
    throw error;
  }
};

// Обновление курса
export const updateCourse = async (
  courseId: number,
  courseData: Partial<Course>
): Promise<Course> => {
  const url = `/courses/${courseId}/`;
  try {
    const response = await axiosInstance.patch<Course>(url, courseData);
    return response.data;
  } catch (error) {
    logger.error("Ошибка при обновлении курса:", error);
    throw error;
  }
};

// Восстановление курса
export const restoreCourse = async (courseId: number): Promise<void> => {
  const url = `/courses/${courseId}/`;
  try {
    await axiosInstance.patch(url, { is_deleted: false });
  } catch (error) {
    logger.error("Ошибка при восстановлении курса:", error);
    throw error;
  }
};

// Мягкое удаление курса
export const softDeleteCourse = async (courseId: number): Promise<void> => {
  const url = `/courses/set_deleted/${courseId}/`;
  try {
    await axiosInstance.patch(url);
  } catch (error) {
    logger.error("Ошибка при мягком удалении курса:", error);
    throw error;
  }
};

// Создание курса
export const createCourse = async (courseData: {
  title: string;
  category: string;
  price: string;
  description: string;
  instructor?: number;
}): Promise<Course> => {
  const url = `/courses/`;
  try {
    const response = await axiosInstance.post<Course>(url, courseData);
    return response.data;
  } catch (error) {
    logger.error("Ошибка при создании курса:", error);
    throw error;
  }
};

// Обновление курса по ID
export const updateCourseById = async (
  id: number,
  courseData: Partial<Course>
): Promise<Course> => {
  const url = `/courses/${id}/`;
  try {
    const response = await axiosInstance.patch<Course>(url, courseData);
    return response.data;
  } catch (error) {
    logger.error(`Ошибка при обновлении курса с ID ${id}:`, error);
    throw error;
  }
};

// Получение категорий
export const fetchCategories = async (): Promise<string[]> => {
  const url = `/courses/categories/`;
  try {
    const response = await axiosInstance.get<string[]>(url);
    return response.data;
  } catch (error) {
    logger.error("Ошибка при загрузке категорий:", error);
    throw error;
  }
};
